import { message } from 'antd';
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getAuth } from "../api/allauth";
import { AuthLoading } from "./AuthLoading";
import { ROUTES } from '../routes';


export default function OAuthCallback() {
    const navigate = useNavigate();
    const didRun = useRef(false);

    useEffect(() => {
        if (didRun.current) return;
        didRun.current = true;

        async function finalizeLogin() {
            try {
                const refreshedAuth = await getAuth();
                if (refreshedAuth.status !== 200) {
                    message.error("There was an issue during authentication. Please, contact support if the problem persists.");
                    navigate(ROUTES.ACCOUNT.LOGIN);
                    return
                }
                const event = new CustomEvent("allauth.auth.change", { detail: refreshedAuth });
                document.dispatchEvent(event);
                message.success("Happy learning.");
                navigate("/");
            } catch (err) {
                message.error("We experienced a network issue.  Please, contact support if the issue persists.");
                navigate(ROUTES.ACCOUNT.LOGIN);
            }
        }

        finalizeLogin();
    }, [navigate]);

    return <AuthLoading />;
}
